import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from "@chakra-ui/react"
import { useField } from "formik"
import type React from "react"

interface PCInputProps {
  label: string
  name: string
  description?: string
  [key: string]: any
}

const PCInput: React.FC<PCInputProps> = ({ label, ...props }) => {
  const [field, meta] = useField(props)

  return (
    <FormControl isInvalid={meta.touched && !!meta.error}>
      {props.description && <p>{props.description}</p>}
      <FormLabel htmlFor={props.id || props.name}>
        <strong>{label}</strong>
      </FormLabel>
      <Input {...field} {...props} id={props.id || props.name} />
      {meta.touched && meta.error ? (
        <FormErrorMessage>{meta.error}</FormErrorMessage>
      ) : null}
    </FormControl>
  )
}

export default PCInput
